import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
  ValidationOptions,
  registerDecorator,
  ValidationArguments,
} from 'class-validator';
import Decimal from 'decimal.js';

@ValidatorConstraint()
class NumericStringMaxConstraint implements ValidatorConstraintInterface {
  validate(value: any, args: ValidationArguments) {
    try {
      const decimal = new Decimal(value);

      if (decimal.isNaN()) return false;
      const maxValue: number = args.constraints[0];
      return decimal.lessThanOrEqualTo(maxValue);
    } catch (err) {
      return false;
    }
  }

  defaultMessage(args: ValidationArguments) {
    return `${args.property} must be less than or equal to ${args.constraints[0]}.`;
  }
}

export function NumericStringMax(
  maxValue: number,
  validationOptions?: ValidationOptions,
) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [maxValue],
      validator: NumericStringMaxConstraint,
    });
  };
}
